import React from "react";
import "../pages/Proyect.css";
import green from "../Assets/pizza-desk.png";
import BackButton from "../componets/BackButton";
import htmlp from "../Assets/html_p.png";
import cssp from "../Assets/css_p.png";
import reactt from "../Assets/react_p.png";
import firee from "../Assets/firebase_p.png";

export const PizzaApp = () => {
  const handleWebButtonClick = () => {
    window.location.href = "https://pizza-app-sg.netlify.app/";
  };

  const handleGitHubButtonClick = () => {
    window.location.href = "https://github.com/SusanaLab/Pizza";
  };

  return (
    <div className="proyect-container">
      <BackButton />
      <div className="proyect-header">
        <h1>Pizza App</h1>
    
      <div className="proyect-description">
        <p id="paragraph">
        I developed an interactive web application using React and Firebase called "Pizza App." Designed for the efficient management of pizza restaurants, the application provides specific tools for waiters, kitchen staff, and administrators. The intuitive interface facilitates order creation by waiters, their transmission to the kitchen, and real-time viewing by kitchen staff. Administrators can access daily reports detailing the total pizzas sold and the amount collected. Created with modern technologies, the application enhances operational efficiency and provides a smooth and functional experience.
        </p>
      </div>
      <div className="proyect-buttons">
        <button className="proyect-button" onClick={handleWebButtonClick}>Web</button>
        <button className="proyect-button" onClick={handleGitHubButtonClick}>GitHub</button>
      </div>
      <div className="proyect-tech">
        <p>Technologies</p>
         <img src={htmlp} alt="HTML" className="computer" />
        <img src={cssp} alt="CSS" className="computer" />
        <img src={reactt} alt="React" className="computer" />
        <img src={firee} alt="Firebase" className="computer" />
      </div>  </div>
      <img
        id="new"
        src={green}
        alt="Learning List"
        className="learning-image"
      />
    </div>
  );
};
